import React from 'react';
import { useFormatter } from '../../../../core/formatter/use-formatter';
import isNil from '../../../../core/helpers/is-nil';
import { Typography } from '../../../typography/typography';
import styles from './table-cell-date-time.module.scss';

type Props = {
  date?: Date;
};

export const TableCellDateTime: React.FC<Props> = ({ date }) => {
  const { formatDate } = useFormatter();

  if (isNil(date)) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Typography color="black" variant="maintext">
        {formatDate(date)}
      </Typography>
    </div>
  );
};
